<template>
  <div v-if="$feature.tempEnableBrightedge" class="be-ix-link-block" />
  <vf-footer />
</template>

<script lang="ts" setup>
import VfFooter from '#brand/components/vf/footer/Footer.vue'

const { $feature } = useNuxtApp()
</script>
